import React from 'react';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import ServicePointLocator from './ui/ServicePointLocator';

const PostnordLocation = () => {
  const checkout = useTypedSelector((state) => state.checkout);
  const { validationErrors = {} } = checkout;
  const { selectedServicePointId } = checkout.payload;

  return (
    <div className="flex flex-col gap-4 rounded border border-black p-4">
      <ServicePointLocator
        selectedServicePointId={selectedServicePointId}
        validationErrors={validationErrors}
      />
    </div>
  );
};

export default PostnordLocation;
